// extracted by mini-css-extract-plugin
export default {"offWhite":"#ecfffa","turqoise":"#00c495","darkBlue":"#0f1936","white":"#fff","grey":"#e4e9e4","purle":"#6e7cff","yellowGreen":"#cdf98c","red":"#ff4747"};